<template>
  <div class="img__list">
    <div class="img__list__large">
      <img
        class="img__list__large__img"
        v-if="list[currentIndex]"
        :src="list[currentIndex] + '?x-oss-process=image/resize,w_240/quality,q_90'"
        alt=""
      />
      <img class="img__list__large__img" v-else :src="require('@/assets/img/goods-empty.png')" />
      <img class="special-img" v-if="isSpecial" :src="require('@/assets/img/special.png')" alt="" />
      <div v-if="itemStatus == '1'" class="sellOut">商品已经下架啦～</div>
      <div v-else-if="itemStatus == '2'" class="sellOut">商品已经售罄啦～</div>
    </div>

    <SlideWrap :style="itemStyle" :showArrow="true" v-if="list.length">
      <template #default>
        <template v-for="(img, index) in list">
          <img
            v-if="img"
            :src="img + '?x-oss-process=image/resize,w_240/quality,q_90'"
            :key="index"
            :class="{ img__list__small: true, active: index == currentIndex, pointer: true }"
            @click="handleClickImg(index)"
            @mousemove="handleClickImg(index)"
          />
          <img
            :class="{ img__list__small: true, active: index == currentIndex, pointer: true }"
            :key="'empty' + index"
            v-else
            :src="require('@/assets/img/goods-empty.png')"
          />
        </template>
      </template>
      <template #left>
        <div class="left__arrow vertical-align">
          <img
            class="pointer middle"
            style="vertical-align: middle; width: 30px; height: 32px"
            src="@/assets/img/arrow-left.png"
          />
        </div>
      </template>
      <template #right>
        <div class="right__arrow vertical-align">
          <img
            class="pointer middle"
            style="vertical-align: middle; width: 30px; height: 32px"
            src="@/assets/img/arrow-right.png"
          />
        </div>
      </template>
    </SlideWrap>
  </div>
</template>

<script>
import SlideWrap from '@/components/SlideWrap';
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    itemStatus: {
      type: String,
      default: '0'
    }
  },
  components: {
    SlideWrap
  },

  data() {
    return {
      currentIndex: 0,
      itemStyle: { padding: '0 38px' }
    };
  },
  methods: {
    handleClickImg(index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style lang="scss" scoped>
.img__list {
  width: 350px;
  &__large {
    width: 350px;
    height: 350px;
    position: relative;
    margin-bottom: 12px;
    .special-img {
      height: 50px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    &__img {
      width: 100%;
      height: 100%;
    }
    .sellOut {
      width: 350px;
      height: 44px;
      background: #000000;
      opacity: 0.5;
      font-size: 14px;
      text-align: center;
      line-height: 44px;
      color: #ffffff;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  &__small {
    width: 64px;
    height: 64px;
    & + .img__list__small {
      margin-left: 6px;
    }
  }
  .left__arrow {
    position: absolute;
    left: 0;
    top: 0;
    width: 32px;
    height: 100%;
    border: 1px solid #f5f5f5;
  }
  .right__arrow {
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    height: 100%;
    border: 1px solid #f5f5f5;
  }
  .active {
    border: 1px solid #ff0000;
  }
}
</style>
